import React, { useState } from 'react'

interface TimedSessionModalProps {
  isOpen: boolean
  onClose: () => void
  onStartTimer: (seconds: number) => void
}

const TIMER_OPTIONS = [
  { label: '90 seconds', value: 90 },
  { label: '60 seconds', value: 60 },
  { label: '45 seconds', value: 45 },
  { label: '30 seconds', value: 30 },
  { label: 'Immediate', value: 0 },
]

export const TimedSessionModal: React.FC<TimedSessionModalProps> = ({ isOpen, onClose, onStartTimer }) => {
  const [selected, setSelected] = useState(60)

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-surface rounded-xl shadow-float border border-border w-full max-w-sm mx-4 animate-slide-up">
        <div className="px-5 py-4 border-b border-border">
          <h3 className="text-lg font-semibold text-txt-primary">End Session Timer</h3>
          <p className="text-sm text-txt-secondary mt-0.5">Set a countdown before closing the chat</p>
        </div>

        <div className="px-5 py-4 space-y-2">
          {TIMER_OPTIONS.map(opt => (
            <button
              key={opt.value}
              onClick={() => setSelected(opt.value)}
              className={`w-full flex items-center justify-between px-4 py-2.5 rounded-lg text-sm font-medium border transition-colors ${
                selected === opt.value
                  ? 'border-brand-500 bg-brand-50 text-brand-700 dark:bg-brand-900/20 dark:text-brand-300'
                  : 'border-border text-txt-primary hover:bg-surface-hover'
              }`}
            >
              {opt.label}
              {selected === opt.value && (
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              )}
            </button>
          ))}
        </div>

        <div className="flex items-center justify-end gap-2 px-5 py-3 border-t border-border bg-surface-secondary/50 rounded-b-xl">
          <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm font-medium text-txt-secondary hover:text-txt-primary hover:bg-surface-hover transition-colors">
            Cancel
          </button>
          <button
            onClick={() => { onStartTimer(selected); onClose() }}
            className="px-4 py-2 rounded-lg text-sm font-medium bg-error text-white hover:bg-red-700 transition-colors"
          >
            {selected === 0 ? 'End Now' : 'Start Timer'}
          </button>
        </div>
      </div>
    </div>
  )
}
